/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Grid, Button, Autocomplete, Divider } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import { Vocabulary } from "../../Utils/Vocabulary";
import { FgoItems } from "./FgoMainPage";
import { useEffect, useState } from "react";
import { TaxRateModel } from "../../Utils/Models";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { Delete } from "@mui/icons-material";

type FgoContentFormProps = {
  contentItems: Array<FgoItems>;
  handleContentChange: (index: number, field: string, value: any) => any;
  addContentItem: () => void;
  removeContentItem: (index: number) => void;
};

export default function FgoContentForm(props: FgoContentFormProps) {
  const {
    contentItems,
    handleContentChange,
    addContentItem,
    removeContentItem,
  } = props;
  const [vatList, setVatList] = useState<Array<TaxRateModel>>([]);

  useEffect(() => {
    const getVatList = async () => {
      const data = (await getData(`${urlEnum.taxRates}`)).data;
      setVatList(data.result);
    };
    getVatList();
  }, []);

  return (
    <Grid container spacing={2} style={{ marginTop: 10 }}>
      {contentItems.map((item, index: number) => (
        <Grid item xs={12} key={index}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <div
                onClick={() => {
                  removeContentItem(index);
                }}
                style={{ width: "fit-content" }}
              >
                <Delete color="error" style={{ cursor: "pointer" }} />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextValidator
                size="small"
                name="name"
                label={Vocabulary.name}
                fullWidth
                variant="outlined"
                value={item.Denumire}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
                onChange={(e: any) =>
                  handleContentChange(index, "Denumire", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextValidator
                size="small"
                name="quantity"
                label={Vocabulary.costcenter}
                fullWidth
                variant="outlined"
                value={item.CodCentruCost}
                onChange={(e: any) =>
                  handleContentChange(index, "CodCentruCost", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextValidator
                size="small"
                name="name"
                label={Vocabulary.articleCode}
                fullWidth
                variant="outlined"
                value={item.CodArticol}
                onChange={(e: any) =>
                  handleContentChange(index, "CodArticol", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextValidator
                size="small"
                name="name"
                label={Vocabulary.inventoryCode}
                fullWidth
                variant="outlined"
                value={item.CodGestiune}
                onChange={(e: any) =>
                  handleContentChange(index, "CodGestiune", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextValidator
                size="small"
                name="name"
                label={Vocabulary.description}
                fullWidth
                variant="outlined"
                value={item.Descriere}
                onChange={(e: any) =>
                  handleContentChange(index, "Descriere", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextValidator
                size="small"
                name="unitPrice"
                label={Vocabulary.unitPrice}
                fullWidth
                variant="outlined"
                value={item.PretUnitar}
                onChange={(e: any) =>
                  handleContentChange(index, "PretUnitar", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextValidator
                size="small"
                name="quantity"
                label={Vocabulary.totalPrice}
                fullWidth
                variant="outlined"
                value={item.PretTotal}
                onChange={(e: any) =>
                  handleContentChange(index, "PretTotal", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextValidator
                size="small"
                name="quantity"
                label={Vocabulary.unitMeasure}
                fullWidth
                variant="outlined"
                value={item.UM}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
                onChange={(e: any) =>
                  handleContentChange(index, "UM", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextValidator
                size="small"
                name="quantity"
                label={Vocabulary.quantity}
                fullWidth
                variant="outlined"
                value={item.NrProduse}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
                onChange={(e: any) =>
                  handleContentChange(index, "NrProduse", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Autocomplete
                size="small"
                id="type"
                freeSolo={true}
                options={vatList}
                disabled={false}
                value={vatList.find((value) => value.value === item.CotaTVA)}
                getOptionLabel={(option: any) => option.name}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.name === value.name
                }
                renderInput={(params: any) => (
                  <TextValidator
                    {...params}
                    fullWidth
                    label={Vocabulary.vat}
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          </Grid>
          <Divider style={{ margin: "20px 0" }} />
        </Grid>
      ))}
      <Grid item xs={12}>
        <Button variant="outlined" onClick={addContentItem}>
          Add Content Item
        </Button>
      </Grid>
    </Grid>
  );
}
